const emojiUrl = '//s1.music.126.net/style/web2/emt/emoji_{ID}.png';
const emojiMap = {
    "大笑":"86",
    "可爱":"85",
    "憨笑":"359",
    "色":"95",
    "亲亲":"363",
    "惊恐":"96",
    "流泪":"356",
    "亲":"362",
    "呆":"352",
    "哀伤":"342",
    "呲牙":"343",
    "吐舌":"348",
    "撇嘴":"353",
    "怒":"361",
    "奸笑":"341",
    "汗":"97",
    "痛苦":"346",
    "惶恐":"354",
    "生病":"350",
    "口罩":"351",
    "大哭":"357",
    "晕":"355",
    "发怒":"115",
    "开心":"360",
    "鬼脸":"94",
    "皱眉":"87",
    "流感":"358",
    "爱心":"33",
    "心碎":"34",
    "钟情":"303",
    "星星":"309",
    "生气":"314",
    "便便":"89",
    "强":"13",
    "弱":"372",
    "拜":"14",
    "牵手":"379",
    "跳舞":"380",
    "禁止":"374",
    "这边":"262",
    "爱意":"106",
    "示爱":"376",
    "嘴唇":"367",
    "狗":"81",
    "猫":"78",
    "猪":"100",
    "兔子":"459",
    "小鸡":"450",
    "公鸡":"461",
    "幽灵":"116",
    "圣诞":"411",
    "外星":"101",
    "钻石":"52",
    "礼物":"107",
    "男孩":"0",
    "女孩":"1",
    "蛋糕":"337",
    "18":"186",
    "圈":"312",
    "叉":"313"
}
//根据num分割emoji
const splitEmoji = (num) => {
    let arr = [];
    let temp = [];
    let i = 1;
    let index = 0;
    let isnum = typeof num == 'number';
    for(let p in emojiMap){
        if(p != 18){
            if(!arr[index]){
                arr[index] = [];
            }
            arr[index].push({
                key : p,
                value : emojiMap[p]
            });
            //console.log(i);
            if(isnum && i % num == 0){
                index++;
            }
            i++;
        }
    }
    arr[index].splice(arr[index].length - 2, 0, {key:'18', value:'186'});
    return arr;
}
//输出真实的url
const getEmojiURL = function(id){
    return id ? emojiUrl.replace('{ID}',id) : '';
};
export {emojiMap}
export {emojiUrl}
export {splitEmoji}
export {getEmojiURL}


// WEBPACK FOOTER //
// ./client/component/emoji/emoji.js